import React, { useState } from 'react';
import { X, Plus } from 'lucide-react';

const colorVariants = {
  blue: {
    tag: 'bg-blue-100 text-blue-800 border-blue-200',
    remove: 'text-blue-600 hover:text-blue-800',
    button: 'bg-blue-600 hover:bg-blue-700'
  },
  green: {
    tag: 'bg-green-100 text-green-800 border-green-200',
    remove: 'text-green-600 hover:text-green-800',
    button: 'bg-green-600 hover:bg-green-700'
  },
  purple: {
    tag: 'bg-purple-100 text-purple-800 border-purple-200',
    remove: 'text-purple-600 hover:text-purple-800',
    button: 'bg-purple-600 hover:bg-purple-700'
  },
  orange: {
    tag: 'bg-orange-100 text-orange-800 border-orange-200',
    remove: 'text-orange-600 hover:text-orange-800',
    button: 'bg-orange-600 hover:bg-orange-700'
  },
  red: {
    tag: 'bg-red-100 text-red-800 border-red-200',
    remove: 'text-red-600 hover:text-red-800',
    button: 'bg-red-600 hover:bg-red-700'
  },
  indigo: {
    tag: 'bg-indigo-100 text-indigo-800 border-indigo-200',
    remove: 'text-indigo-600 hover:text-indigo-800',
    button: 'bg-indigo-600 hover:bg-indigo-700'
  },
  gray: {
    tag: 'bg-gray-100 text-gray-800 border-gray-200',
    remove: 'text-gray-600 hover:text-gray-800',
    button: 'bg-gray-600 hover:bg-gray-700'
  }
};

export const TagInput = ({
  items = [],
  onAdd,
  onRemove,
  placeholder = 'Add item...',
  color = 'blue',
  disabled = false,
  icon: Icon,
  inputLabel,
  addLabel = 'Ajouter',
  removeLabel = (item) => `Retirer ${item}`
}) => {
  const [input, setInput] = useState('');
  const variant = colorVariants[color] || colorVariants.blue;

  const handleAdd = () => {
    const trimmed = input.trim();
    if (trimmed && !items.includes(trimmed)) {
      onAdd(trimmed);
      setInput('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAdd();
    }
  };

  return (
    <div>
      <div className="flex gap-2">
        {Icon && <Icon size={16} className="mt-2.5 text-gray-400 flex-shrink-0" />}
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          className="min-w-0 flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder={placeholder}
          disabled={disabled}
          aria-label={inputLabel}
        />
        <button
          type="button"
          onClick={handleAdd}
          disabled={!input.trim() || disabled}
          className={`min-h-[44px] min-w-[44px] px-4 py-2 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 disabled:opacity-50 disabled:cursor-not-allowed ${variant.button}`}
          aria-label={addLabel}
        >
          <Plus size={16} />
        </button>
      </div>

      {items.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3">
          {items.map((item, index) => (
            <span
              key={index}
              className={`inline-flex items-center px-3 py-1 rounded-full text-sm border ${variant.tag}`}
            >
              {item}
              <button
                type="button"
                onClick={() => onRemove(item)}
                className={`ml-2 ${variant.remove}`}
                disabled={disabled}
                aria-label={removeLabel(item)}
              >
                <X size={12} />
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
